export const INPUTS = {
  transactions: [
    {
      key: 'defaultCategory',
      weight: 2
    },
    {
      key: 'budget',
      weight: 3
    },
    {
      key: 'mandatoryTagTypes',
      weight: 53
    },
    {
      key: 'notes',
      weight: 54
    },
    {
      key: 'receiptNumber',
      weight: 90
    },
    {
      key: 'provider',
      weight: 91
    },
    {
      key: 'providerData',
      weight: 92
    },
    {
      key: 'address',
      weight: 93
    },
    {
      key: 'zipCode',
      weight: 94
    },
    {
      key: 'city',
      weight: 95
    },
    {
      key: 'state',
      weight: 96
    },
    {
      key: 'country',
      weight: 97
    },
    {
      key: 'noMandatoryTagTypes',
      weight: 98
    },
    {
      key: 'vatTypeAssigned',
      weight: 99
    },
    {
      key: 'taxes',
      weight: 100
    }
  ],
  expenses: [
    {
      key: 'paymentMethod',
      weight: 2
    },
    {
      key: 'defaultCategory',
      weight: 3
    },
    {
      key: 'budget',
      weight: 4
    },
    {
      key: 'amount',
      weight: 5
    },
    {
      key: 'date',
      weight: 6
    },
    {
      key: 'provider',
      weight: 7
    },
    {
      key: 'mandatoryTagTypes',
      weight: 53
    },
    {
      key: 'notes',
      weight: 54
    },
    {
      key: 'receiptNumber',
      weight: 90
    },
    {
      key: 'providerData',
      weight: 91
    },
    {
      key: 'address',
      weight: 92
    },
    {
      key: 'zipCode',
      weight: 93
    },
    {
      key: 'city',
      weight: 94
    },
    {
      key: 'state',
      weight: 95
    },
    {
      key: 'country',
      weight: 96
    },
    {
      key: 'noMandatoryTagTypes',
      weight: 97
    },
    {
      key: 'vatTypeAssigned',
      weight: 98
    },
    {
      key: 'taxes',
      weight: 99
    }
  ]
}
